import { FollowSuggestionUtil } from "@api-commons/cta/FollowSuggestionUtil.js";
import { UserRole } from "../../../login/UserRole.js";
import { Logger } from "@ciaopeople/cp-shatsu/Logging";
import { ClientSdkPublicInterface } from "../../../sdk/ClientSdkPublicInterface.js";
import { SubscriptionStatus } from "../../../subscriptions/PushServiceInterface.js";
import { EvaluatedActionType, ProposeAppDownload, ProposeSubscription } from "../../EvaluatedAction.js";
import { NotificationSystemType } from "../../../api/types/SubscriptionTypes.js";

export function evaluateSubscriptionProposal(sdk: ClientSdkPublicInterface, logger: Logger): Promise<ProposeSubscription|ProposeAppDownload|null> {    
    const detectedWebview = sdk.webviewDetect();
    const session = sdk.getCurrentSession();
    
    if (sdk.getPushService().isSystemEnabled() && session && session.role == UserRole.AUTHENTICATED_USER) {
        return sdk.getPushService().getSubscriptionsAndCheckCurrentDevice().then(
            subscriptions => {
                logger.debug("Current subscriptions", subscriptions);
                if(detectedWebview.native_app) {
                    
                    if (subscriptions.subscriptionStatus !== SubscriptionStatus.ENABLED) {
                        logger.info("Pushnot native app no subscriptions");
                        return {
                            type: EvaluatedActionType.PROPOSE_PUSH_NOT_SUBSCRIPTION,
                            data:null
                        };
                    }
                    else {
                        logger.info("Pushnot native app go to follow");
                        const suggestionUtil = new FollowSuggestionUtil(sdk, logger);
                        return suggestionUtil.getPageSuggestedTopic().then(topic => {
                            if(topic) {
                                return {
                                    type: EvaluatedActionType.PROPOSE_FOLLOW,
                                    data: topic
                                };
                            }
                            else return null;
                        });
                    }
                }
                else {
                    const suggestionUtil = new FollowSuggestionUtil(sdk, logger);
                    return suggestionUtil.getPageSuggestedTopic().then(topic => {
                        if (subscriptions.device) {
                            logger.info("Pushnot has notifications going for follow", topic);
                            if(topic) {
                                return {
                                    type: EvaluatedActionType.PROPOSE_FOLLOW,
                                    data: topic
                                };
                            }
                            else return null;
                        }
                        else{
                           
                            if (!detectedWebview.browser.safari && subscriptions.otherDevices && subscriptions.otherDevices.filter(d => d.notificationSystemType == NotificationSystemType.WebPushVAPID).length > 0 ) {
                                logger.debug("Pushnot re enable on legacy");
                                return {
                                    type: EvaluatedActionType.SUGGEST_RE_ENABLE_LEGACY_PUSH_NOT,
                                    data: topic
                                };
                            }
                            else {
                                logger.info("Pushnot bottom case");
                                return {
                                    type: EvaluatedActionType.PROPOSE_PUSH_NOT_SUBSCRIPTION,
                                    data: topic
                                };  
                            }
                            
                        }
                    });
                    
                }
                
            }
        );
        
    }
    else {
        logger.info("System not enabled or user not logged in enable?", sdk.getPushService().isSystemEnabled());
        return Promise.resolve(null);
    }
                
}


